export const HC = {
  canvas: "#FBF8F2", panel: "#FFFFFF", panelSoft: "#FDFBF6",
  border: "#EFE7DA", borderSoft: "#F5EFE4",
  text: "#33221E", muted: "#8B7355", soft: "#A99483",
  burgundy: "#8B1E1E", burgundyDark: "#6E1414", burgundySoft: "#FBEDED",
  gold: "#C49A4A", goldSoft: "#FDF4E2",
  green: "#2E7D32", greenTint: "#E8F3E8",
  amber: "#D97706", amberTint: "#FDF3DD",
  red: "#C62828", redTint: "#FBE9E9",
  purple: "#6B4EA8", purpleTint: "#EFEAF9",
  blue: "#1E5FBF", blueTint: "#E8F1FD",
};

export const STATUS_TONE = {
  active: [HC.green, HC.greenTint], present: [HC.green, HC.greenTint],
  approved: [HC.green, HC.greenTint], completed: [HC.green, HC.greenTint],
  paid: [HC.green, HC.greenTint], scheduled: [HC.blue, HC.blueTint],
  probation: [HC.amber, HC.amberTint], late: [HC.amber, HC.amberTint],
  pending: [HC.amber, HC.amberTint], pending_approval: [HC.amber, HC.amberTint],
  processing: [HC.green, HC.greenTint], calculated: [HC.blue, HC.blueTint],
  validated: [HC.blue, HC.blueTint], payslips_generated: [HC.purple, HC.purpleTint],
  posted: [HC.purple, HC.purpleTint], on_leave: [HC.purple, HC.purpleTint],
  swapped: [HC.purple, HC.purpleTint], suspended: [HC.red, HC.redTint],
  absent: [HC.red, HC.redTint], rejected: [HC.red, HC.redTint],
  terminated: [HC.red, HC.redTint], resigned: [HC.soft, HC.borderSoft],
  draft: [HC.muted, HC.borderSoft],
};

export const tone = (s) => STATUS_TONE[s] || [HC.muted, HC.borderSoft];
export const label = (s) => (s || "—").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
export const DEPT_COLORS = [HC.red, HC.gold, HC.green, HC.blue, HC.purple, "#0E9488", "#DB2777", "#65A30D"];
